import { useQuery } from '@tanstack/react-query';

import { fetchCargoClaimsApi } from '../api';

/*
 * The claims the signed-in user may see.
 *
 * Scoped by the service, not here: it reads the caller's policy holders from
 * the session the gateway validated and restricts the query to them. A user
 * carrying no policy holders is served nothing rather than everything, which
 * is the opposite of what list five does.
 */
export default function useCargoClaimsQuery(filter: any, options?: any) {
  return useQuery(['cargo', 'claims', filter], fetchCargoClaimsApi, options);
}
